module.exports = __webpack_public_path__ + "static/media/Pixelit_svg.f3bf0b34.svg";